export const isValidDate = (date: unknown) => (
  !Number.isNaN(Date.parse(date as string))
)